import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toHtml from "html-react-parser";
import Breadcrums from "../../../common/breadcrumbs";
import Loader from "../../../common/loader";
import { capitalizeFirstLetter, formateDate, showStatus } from "../../../../../utils/commonfunction";
import * as customerServices from "../../../services/customerServices.js";
import { useTranslation } from "react-i18next";

const CustomerView = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [showdefault, setShowDefault] = useState({});

  const breadcrumbs = [
    { title: t("link_dashboard"), url: "/admin/dashboard" },
    { title: t("Customer Management"), url: "/admin/customerManagement/customers/list/1" },
    { title: t("link_view"), url: "" },
  ];

  useEffect(() => {
    customerServices
      .Details(params.id)
      .then((data) => {
        setShowDefault(data && data.data ? data.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, []);

  // Fields to skip entirely — internal/system fields not for display
  const SKIP_FIELDS = [
    "_id",
    "terms_accepted",
    "privacy_accepted",
    "accountProvider",
    "referral_link",
    "stylist_referral_link",
    "pinterest_link",
    "id",
    "password",
    "token",
    "otp",
    "otp_expire",
    "emailVerifyToken",
    "emailVerifyExpires",
    "validate_string",
    "stylist_profile_slugs",
    "notification_settings",
    "privacy_settings",
    "blocked_users",
    "following_users",
    "followers_users",
  ];

  // Check if value is valid (not null, undefined, empty string, "null", empty array, empty object)
  const isValid = (value) => {
    if (value === null || value === undefined) return false;
    if (typeof value === "string" && (value.trim() === "" || value.trim() === "null" || value.trim() === "[]" || value.trim() === "{}")) return false;
    if (Array.isArray(value) && value.length === 0) return false;
    if (typeof value === "object" && !Array.isArray(value) && Object.values(value).every((v) => v === "" || v === null || v === undefined)) return false;
    return true;
  };

  // Convert field key to readable label
  const formatLabel = (key) => {
    return key
      .replace(/_/g, " ")
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/\b\w/g, (c) => c.toUpperCase());
  };

  // Format value based on type
  const formatValue = (key, value) => {
    if (key === "status") return <span>{toHtml(showStatus(value))}</span>;
    if (key === "DOB" || key === "createdAt" || key === "updatedAt") return formateDate(value);

    if (key === "profile_image") {
      return (
        <div className="avatar avatar-xxl mb-2">
          <img src={value} alt="Profile" className="rounded-circle border" style={{ width: "100px", height: "100px", objectFit: "cover" }} />
        </div>
      );
    }

    if (key === "full_body_image" && Array.isArray(value) && value.length > 0) {
      return (
        <div className="d-flex flex-wrap gap-2">
          {value.map((img, idx) => (
            <img key={idx} src={img} alt={`Body ${idx}`} className="img-thumbnail" style={{ width: "120px", height: "160px", objectFit: "cover" }} />
          ))}
        </div>
      );
    }

    if (typeof value === "boolean") {
      return value ? <span className="badge bg-success">Yes</span> : <span className="badge bg-danger">No</span>;
    }

    if (Array.isArray(value)) return value.length > 0 ? value.join(", ") : "None";

    if (typeof value === "object" && value !== null) {
      const entries = Object.entries(value).filter(([, v]) => isValid(v));
      if (entries.length === 0) return null;
      return (
        <div className="d-flex flex-wrap" style={{ gap: "10px 20px" }}>
          {entries.map(([k, v]) => (
            <div key={k} className="d-inline-block">
              <strong className="text-dark">{formatLabel(k)}:</strong>
              <span className="ms-1">{String(v)}</span>
            </div>
          ))}
        </div>
      );
    }
    return value;
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">{t("heading_customer")}</h6>
              </div>
              {showdefault && Object.keys(showdefault)?.length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table id="simple-table" className="table table-bordered table-hover">
                      <tbody>
                        {Object.entries(showdefault)
                          .filter(([key, value]) => !SKIP_FIELDS.includes(key) && isValid(value))
                          .map(([key, value]) => {
                            const formattedValue = formatValue(key, value);
                            if (!formattedValue) return null;
                            return (
                              <tr key={key}>
                                <th>{formatLabel(key)}</th>
                                <td className="text-capitalize" style={{ wordBreak: "break-word" }}>
                                  {formattedValue}
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                    <div className="mt-5">
                      <button className="btn ripple btn-dark" type="button" onClick={() => navigate(-1)}>
                        <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                        {t("btn_back")}
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <Loader />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomerView;
